// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as WavePortalJson from "./utils/WavePortal.json";

var _abi = WavePortalJson;

var abi = _abi.default;

var ethereum = {
  LAZY_DONE: false,
  VAL: (function () {
      return Caml_option.nullable_to_opt(window.ethereum);
    })
};

function request(ethereum, method) {
  return ethereum.request({
              method: method
            });
}

export {
  _abi ,
  abi ,
  ethereum ,
  request ,
  
}
/* _abi Not a pure module */
